import { Col } from "antd";
import AppAnimate from "@lib/components/AppComponents/AppAnimate";
import AppRowContainer from "@lib/components/AppComponents/AppRowContainer";
import AppsContainer from "@lib/components/AppComponents/AppsContainer";
import { useIntl } from "react-intl";
import {
  TftSalesLeadsMiniCard,
  TftSalesCallsMiniCard,
} from "@app/admin/dashboards/components/MiniCards";
import { useDateRange } from "@lib/hooks/useDateRange";
import { useMemo, useCallback } from "react";
import { Dayjs } from "dayjs";
import { useQuery } from "@tanstack/react-query";
import {
  apiGetXAILeadsDashboard,
  apiGetXAICallLogsDashboard,
} from "@lib/api/xAI";
import { DateRangeFilter } from "@lib/components/MiniComponents/Others";
import dayjs from "dayjs";
import {
  TftSalesLeadsStatusChart,
  TftSalesLeadsDailyChart,
  TftSalesCallsStatusChart,
  TftSalesCallsAgentChart,
  TftSalesCallsDailyChart,
} from "@lib/components/MiniComponents/Dashboard/TftSales";
import { memo } from "react";
import _ from "lodash";

const TftSalesDashboard = () => {
  const { messages } = useIntl();

  const { dateBetween, setDateBetween } = useDateRange({
    initialRange: "monthly",
    cache: true,
  });

  const handleDateBetween = useCallback(
    (date: [Dayjs, Dayjs]) => {
      setDateBetween(date);
    },
    [setDateBetween],
  );

  const dashboardParams = useMemo(() => {
    return {
      timeFrom: dayjs(dateBetween[0]).toISOString(),
      timeTo: dayjs(dateBetween[1]).toISOString(),
    };
  }, [dateBetween]);

  const leadsQuery = useQuery({
    queryKey: ["tft-sales-leads-dashboard", JSON.stringify(dashboardParams)],
    queryFn: () => apiGetXAILeadsDashboard(dashboardParams),
    enabled: !!dashboardParams,
  });

  const callsQuery = useQuery({
    queryKey: ["tft-sales-calls-dashboard", JSON.stringify(dashboardParams)],
    queryFn: () => apiGetXAICallLogsDashboard(dashboardParams),
    enabled: !!dashboardParams,
  });

  return (
    <AppsContainer
      title={messages["sidebar.dashboard.tftSales"] as string}
      fullView
      cardStyle={{
        background: "transparent",
        boxShadow: "none",
      }}
      showDateRange={true}
      dateRangeValue={dateBetween}
      onDateRangeChange={handleDateBetween}
    >
      <AppAnimate animation="transition.slideUpIn" delay={200}>
        <AppRowContainer>
          {/* Mini Cards */}
          <Col xs={24} md={12} lg={12} xl={12}>
            <TftSalesLeadsMiniCard cardProps={{ borderFull: true }} />
          </Col>
          <Col xs={24} md={12} lg={12} xl={12}>
            <TftSalesCallsMiniCard cardProps={{ borderFull: true }} />
          </Col>

          {/* <Col xs={24} md={12} lg={18} xl={18}>
            <AppRowContainer>
              <Col xs={24}>
                <TftSalesLiveMonitoringCenter
                  query={callsQuery}
                  extra={<DateRangeFilter value={dateBetween} onlyShowDate />}
                  refetch={() => callsQuery.refetch()}
                />
              </Col>

              <Col xs={24}>
                <TftSalesAgentPerformance
                  query={callsQuery}
                  extra={<DateRangeFilter value={dateBetween} onlyShowDate />}
                  refetch={() => callsQuery.refetch()}
                />
              </Col>
            </AppRowContainer>
          </Col> */}

          {/* Conversation Intelligence - Full Width */}
          {/* <Col xs={24} md={12} lg={6} xl={6}>
            <TftSalesConversationIntelligence
              query={callsQuery}
              extra={<DateRangeFilter value={dateBetween} onlyShowDate />}
              refetch={() => callsQuery.refetch()}
            />
          </Col> */}

          {/* Charts */}
          <Col xs={24} md={24} lg={12} xl={12}>
            <TftSalesLeadsStatusChart
              query={leadsQuery}
              extra={<DateRangeFilter value={dateBetween} onlyShowDate />}
              refetch={() => leadsQuery.refetch()}
            />
          </Col>

          <Col xs={24} md={24} lg={12} xl={12}>
            <TftSalesCallsStatusChart
              query={callsQuery}
              extra={<DateRangeFilter value={dateBetween} onlyShowDate />}
              refetch={() => callsQuery.refetch()}
            />
          </Col>

          <Col xs={24} md={24} lg={12} xl={12}>
            <TftSalesCallsAgentChart
              query={callsQuery}
              extra={<DateRangeFilter value={dateBetween} onlyShowDate />}
              refetch={() => callsQuery.refetch()}
            />
          </Col>

          <Col xs={24} md={24} lg={12} xl={12}>
            <TftSalesLeadsDailyChart
              query={leadsQuery}
              extra={<DateRangeFilter value={dateBetween} onlyShowDate />}
              refetch={() => leadsQuery.refetch()}
            />
          </Col>

          <Col xs={24} md={24} lg={24} xl={24}>
            <TftSalesCallsDailyChart
              query={callsQuery}
              extra={<DateRangeFilter value={dateBetween} onlyShowDate />}
              refetch={() => callsQuery.refetch()}
            />
          </Col>
        </AppRowContainer>
      </AppAnimate>
    </AppsContainer>
  );
};

export default memo(TftSalesDashboard, (prevProps, nextProps) => {
  return _.isEqual(prevProps, nextProps);
});
